<div class="wrapper">
  <form
    [formGroup]="OTPFormGroup"
    *ngIf="OTPFormGroup"
    (ngSubmit)="setNewPassword()"
  >
    <div class="title">
      <h1>{{ "OPTPage.setNewPassword" | translate }}</h1>
    </div>
    <div class="inputs">
      <div class="input">
        <label for="password">{{ "OPTPage.newPassword" | translate }}</label>
        <input
          type="password"
          class="form-control"
          id="password"
          formControlName="newPassword"
        />
      </div>
      <div class="input">
        <label for="confirmPassword">{{
          "OPTPage.confirmPassword" | translate
        }}</label>
        <input
          type="password"
          class="form-control"
          id="confirmPassword"
          formControlName="oldPassword"
        />
        <div class="error-message" *ngIf="showErrorMessage">
          <span>{{ errorMessage }}</span>
        </div>
      </div>
    </div>

    <div class="submit">
      <button
        [disabled]="OTPFormGroup.invalid"
        type="submit"
        class="btn btn-block btn-outline-primary"
      >
        {{ "OPTPage.save" | translate }}
      </button>
    </div>
  </form>
</div>
